import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=b897a638&scoped=true"
import script from "./manual.vue?vue&type=script&lang=js"
export * from "./manual.vue?vue&type=script&lang=js"
import style0 from "./manual.vue?vue&type=style&index=0&id=b897a638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897a638",
  null
  
)

export default component.exports